import LegalPageLayout from "./LegalPageLayout";

const TermsConditions = () => (
  <LegalPageLayout
    eyebrow="Legal"
    title="Terms & Conditions"
    effectiveDate="22 May 2025"
  >
    <h2>Acceptance of Terms</h2>
    <p>
      By accessing or using the SpearBI Reporting System ("Service"), you agree
      to be bound by these Terms &amp; Conditions ("Terms"). If you do not
      agree, you must not use the Service.
    </p>

    <h2>Definitions</h2>
    <p>
      <strong>User:</strong> any individual or entity accessing the Service.
    </p>
    <p>
      <strong>Account:</strong> the credentials you use to access the Service.
    </p>
    <p>
      <strong>Data:</strong> any information you upload, enter or otherwise
      transmit to the Service.
    </p>

    <h2>License</h2>
    <p>
      We grant you a limited, non-exclusive, non-transferable, revocable license
      to use the Service for your internal business purposes in accordance with
      these Terms.
    </p>

    <h2>User Obligations</h2>
    <ul>
      <li>You must provide accurate registration information and keep it up to date.</li>
      <li>You are responsible for safeguarding your Account credentials and for any activity under your Account.</li>
      <li>You must comply with all applicable laws and regulations when using the Service.</li>
    </ul>

    <h2>Prohibited Conduct</h2>
    <p>You must not:</p>
    <ul>
      <li>Reverse engineer, decompile or attempt to extract source code.</li>
      <li>Use the Service to transmit malicious code or infringing content.</li>
      <li>Circumvent any access controls or attempt unauthorized access to other users' data.</li>
    </ul>

    <h2>Intellectual Property</h2>
    <p>
      All rights, title and interest in the Service (including all software,
      visual interfaces, and Content) are owned by SpearBI (or its licensors).
      You retain ownership of Data you upload; we claim no rights over it beyond
      what's needed to provide the Service.
    </p>

    <h2>Data Backups &amp; Retention</h2>
    <p>
      We perform regular backups but highly recommend you maintain your own
      copies of all Data. We retain inactive Accounts and Data in accordance
      with our Privacy Policy.
    </p>

    <h2>Warranty Disclaimer</h2>
    <p>
      The Service is provided "as is" and "as available," without warranty of
      any kind, whether express or implied, including any implied warranties of
      merchantability or fitness for a particular purpose.
    </p>

    <h2>Limitation of Liability</h2>
    <p>
      To the maximum extent permitted by law, SpearBI will not be liable for
      any indirect, incidental, special or consequential damages, or loss of
      profits, data or goodwill, arising out of or relating to these Terms or
      the Service, even if advised of the possibility of such damages.
    </p>

    <h2>Termination</h2>
    <p>
      We may suspend or terminate your access immediately if you breach these
      Terms. Upon termination, your right to use the Service ends and we may
      delete or anonymize your Data in accordance with our data retention
      policies.
    </p>

    <h2>Changes to Terms</h2>
    <p>
      We may update these Terms from time to time. If material changes are made,
      we'll notify you at least 14 days before they take effect. Continued use
      after the effective date constitutes acceptance of the new Terms.
    </p>

    <h2>Governing Law &amp; Dispute Resolution</h2>
    <p>
      These Terms are governed by the laws of the Republic of South Africa. Any
      disputes will be subject to the exclusive jurisdiction of the courts of
      Johannesburg.
    </p>

    <h2>Contact</h2>
    <p>
      For questions about these Terms, please email{" "}
      <a href="mailto:info@spearbi.org">info@spearbi.org</a>.
    </p>
  </LegalPageLayout>
);

export default TermsConditions;
